import IntegrationsPage from './IntegrationsPage';
export default IntegrationsPage;